import React, { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { kr, idag } from '../lib/format';
import { PageHeader, Card, StatCard } from '../components/ui';
import { TrendingUp, TrendingDown, Wallet, Receipt } from 'lucide-react';

const Rapport = () => {
  const aar = new Date().getFullYear();
  const [fra, setFra] = useState(`${aar}-01-01`);
  const [til, setTil] = useState(idag());
  const [data, setData] = useState(null);

  const last = useCallback(() => {
    api.get('/rapport', { params: { fra, til } }).then((r) => setData(r.data));
  }, [fra, til]);
  useEffect(() => { last(); }, [last]);

  if (!data) return <span className="fm-text-muted">Laster…</span>;

  return (
    <>
      <PageHeader title="Rapporter" subtitle={`${data.fra} – ${data.til}`} />

      <Card style={{ marginBottom: 12 }}>
        <div className="grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
          <div><label>Fra dato</label><input type="date" value={fra} onChange={(e) => setFra(e.target.value)} /></div>
          <div><label>Til dato</label><input type="date" value={til} onChange={(e) => setTil(e.target.value)} /></div>
        </div>
      </Card>

      <div className="grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 12 }}>
        <StatCard label="Inntekter" value={kr(data.inntekter)} color="var(--theme-success)" icon={TrendingUp} />
        <StatCard label="Utgifter"  value={kr(data.utgifter)}  color="var(--theme-danger)"  icon={TrendingDown} />
        <StatCard label="Resultat"  value={kr(data.resultat)}  color="var(--theme-accent)"  icon={Wallet} />
        <StatCard label="MVA å betale" value={kr(data.mva_til_betaling)} color="var(--theme-warning)" icon={Receipt} />
      </div>

      <div className="grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, marginBottom: 12 }}>
        <Card>
          <h3 style={{ margin: '0 0 10px', fontSize: 13, fontWeight: 600 }}>Inntekter per kategori</h3>
          {data.inntekt_kategorier.length === 0
            ? <p className="fm-text-muted" style={{ fontSize: 12 }}>Ingen inntekter i perioden.</p>
            : <KategoriTabell rader={data.inntekt_kategorier} totalt={data.inntekter} farge="var(--theme-success)" />}
        </Card>
        <Card>
          <h3 style={{ margin: '0 0 10px', fontSize: 13, fontWeight: 600 }}>Utgifter per kategori</h3>
          {data.utgift_kategorier.length === 0
            ? <p className="fm-text-muted" style={{ fontSize: 12 }}>Ingen utgifter i perioden.</p>
            : <KategoriTabell rader={data.utgift_kategorier} totalt={data.utgifter} farge="var(--theme-danger)" />}
        </Card>
      </div>

      <Card>
        <h3 style={{ margin: '0 0 10px', fontSize: 13, fontWeight: 600 }}>MVA-oppgjør</h3>
        <table>
          <tbody>
            <tr><td>Utgående MVA (fra inntekter)</td><td style={{ textAlign: 'right', fontWeight: 600 }}>{kr(data.utgaende_mva)}</td></tr>
            <tr><td>Inngående MVA (fra utgifter)</td><td style={{ textAlign: 'right', fontWeight: 600 }}>− {kr(data.inngaende_mva)}</td></tr>
            <tr><td style={{ fontWeight: 700 }}>MVA å betale</td>
                <td style={{ textAlign: 'right', fontWeight: 700, color: 'var(--theme-warning)' }}>{kr(data.mva_til_betaling)}</td></tr>
          </tbody>
        </table>
      </Card>
    </>
  );
};

const KategoriTabell = ({ rader, totalt, farge }) => (
  <table>
    <tbody>
      {rader.map(([kat, sum]) => {
        const pct = totalt > 0 ? (sum / totalt * 100) : 0;
        return (
          <tr key={kat}>
            <td>{kat || '(uten kategori)'}</td>
            <td style={{ width: 120 }}>
              <div style={{ height: 6, background: 'var(--theme-bg-secondary)', borderRadius: 3 }}>
                <div style={{ width: `${pct}%`, height: '100%', background: farge, borderRadius: 3 }} />
              </div>
            </td>
            <td style={{ textAlign: 'right', fontWeight: 600 }}>{kr(sum)}</td>
            <td className="fm-text-muted" style={{ textAlign: 'right', width: 50 }}>{pct.toFixed(0)}%</td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default Rapport;
